import React, { useState } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
interface ScheduleDemoFormProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ScheduleDemoForm({
  isOpen,
  onClose
}: ScheduleDemoFormProps) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    phone: '',
    employees: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      onClose();
      setSubmitted(false);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        phone: '',
        employees: '',
        message: ''
      });
    }, 2000);
  };
  if (!isOpen) return null;
  return <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50" onClick={onClose} data-id="element-3683" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-3684">
        <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden" data-id="element-3685">
          {/* Header */}
          <div className="px-8 py-6 border-b border-gray-200 flex items-center justify-between" data-id="element-3686">
            <div data-id="element-3687">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-3688">
                Schedule a Demo
              </h2>
              <p className="text-sm text-gray-600 mt-1" data-id="element-3689">
                See how ZoomInfo GTM can transform your revenue operations
              </p>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-3690">
              <XIcon className="w-6 h-6 text-gray-500" data-id="element-3691" />
            </button>
          </div>
          {/* Content */}
          <div className="p-8" data-id="element-3692">
            {submitted ? <div className="text-center py-12" data-id="element-3693">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3694">
                  <CheckIcon className="w-8 h-8 text-green-600" data-id="element-3695" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-3696">
                  Thank you!
                </h3>
                <p className="text-gray-600" data-id="element-3697">
                  We will reach out shortly to schedule your demo.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-3698">
                <div className="grid grid-cols-2 gap-4" data-id="element-3699">
                  <div data-id="element-3700">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3701">
                      First Name *
                    </label>
                    <input type="text" required value={formData.firstName} onChange={e => setFormData({
                  ...formData,
                  firstName: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-3702" />
                  </div>
                  <div data-id="element-3703">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3704">
                      Last Name *
                    </label>
                    <input type="text" required value={formData.lastName} onChange={e => setFormData({
                  ...formData,
                  lastName: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-3705" />
                  </div>
                </div>
                <div data-id="element-3706">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3707">
                    Work Email *
                  </label>
                  <input type="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-3708" />
                </div>
                <div data-id="element-3709">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3710">
                    Company *
                  </label>
                  <input type="text" required value={formData.company} onChange={e => setFormData({
                ...formData,
                company: e.target.value
              })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-3711" />
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-3712">
                  <div data-id="element-3713">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3714">
                      Phone
                    </label>
                    <input type="tel" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-3715" />
                  </div>
                  <div data-id="element-3716">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3717">
                      Company Size
                    </label>
                    <select value={formData.employees} onChange={e => setFormData({
                  ...formData,
                  employees: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-3718">
                      <option value="" data-id="element-3719">Select...</option>
                      <option value="1-10" data-id="element-3720">1-10</option>
                      <option value="11-50" data-id="element-3721">11-50</option>
                      <option value="51-200" data-id="element-3722">51-200</option>
                      <option value="201-500" data-id="element-3723">201-500</option>
                      <option value="501-1000" data-id="element-3724">501-1000</option>
                      <option value="1000+" data-id="element-3725">1000+</option>
                    </select>
                  </div>
                </div>
                <div data-id="element-3726">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3727">
                    Tell us about your GTM challenges
                  </label>
                  <textarea value={formData.message} onChange={e => setFormData({
                ...formData,
                message: e.target.value
              })} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-3728" />
                </div>
                <button type="submit" className="w-full px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium" data-id="element-3729">
                  Schedule Demo
                </button>
              </form>}
          </div>
        </div>
      </div>
    </>;
}